/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toRoomUnreadProps } from './translator/roomUnread'
import { toTalkProps } from './translator/talk'
import { toTalkReaderProps } from './translator/talkReader'
import { FetchUnread, PutReadRoom, PutUnreadRoom, PutReadTalk, GetTalkReaders } from '@/infrastructure/network/Monitaro/requests/read'

export default class Read extends MonitaroGatewayBase {
  async FetchUnread() {
    const { reads } = await this.apiClient.request(new FetchUnread())
    return toRoomUnreadProps(reads)
  }

  async PutReadRoom(room: string) {
    const { read } = await this.apiClient.request(new PutReadRoom(room))
    return read
  }

  async PutUnreadRoom(room: string) {
    const { unread } = await this.apiClient.request(new PutUnreadRoom(room))
    return unread
  }

  async PutReadTalk(id: string) {
    const { talk } = await this.apiClient.request(new PutReadTalk(id))
    return toTalkProps(talk)
  }

  async GetTalkReaders(talk: string) {
    const { readers } = await this.apiClient.request(new GetTalkReaders(talk))
    return toTalkReaderProps(readers)
  }
}
